import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const RFQListCont = styled.div((props) => ({
  marginTop:'1rem',
  // width:'80vw',
  // maxWidth:'90vw',

  '.ui.table':{
    borderWidth:0
  },

  '.ReactTable .rt-thead.-header':{
    boxShadow:'none',
    background: '#eaeff5'
  },

  '.ReactTable':{
    borderRadius:'0.5rem'
  },

  '.ReactTable .rt-thead .rt-th':{
    borderRight: 0
  },

  '.ReactTable .rt-tbody .rt-td':{
    borderRight: 0
  },

  '.-padRow':{
    cursor:'default !important'
  },

  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },

  '@media only screen and (min-width: 600px)': {
    // width: '100vw',
  },

  '@media only screen and (min-width: 769px)': {
    width: '80vw',
  },

}))

export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))

export const RFQStdCont = styled.div((props) => ({
  // 'div.fieldInput input:disabled':{background:'#fff !important'},
  // 'div.fieldInput .ui.disabled':{background:'#fff !important'},
  // 'div.fieldInput textarea:disabled':{background:'#fff !important'},
  // 'div.fieldInput':{
  //   'div.disabled':{
  //     'i':{
  //       visibility:'hidden'
  //     }
  //   }
  // }

  '&>div>div.ui.menu': {
    overflowX: 'scroll',
  },

  '@media only screen and (min-width: 600px)': {
    '&>div>div.ui.menu': {
      overflowX: 'unset',
    },
  },

  '@media only screen and (min-width: 769px)': {
    '&>div>div.ui.menu': {
      overflowX: 'unset',
    },
  }
}))

export const RFQContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  
  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',

    '.collectiveButtons': {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '10px',

      '&>button': {
        height: '2.375rem', 
        margin: 'auto 0.375rem'
      },
    }
  },

  '@media only screen and (min-width: 600px)': {
    '.rowFields': {
      flexDirection: 'row',

      '.collectiveButtons': {
        marginBottom: '0px',
      },
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.rowFields': {
      flexDirection: 'row',

      '.collectiveButtons': {
        marginBottom: '0px',
      },
    },
  },
})
